<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.3346 10.0013C18.3346 14.6036 14.6036 18.3346 10.0013 18.3346C5.39893 18.3346 1.66797 14.6036 1.66797 10.0013C1.66797 5.39893 5.39893 1.66797 10.0013 1.66797C14.6036 1.66797 18.3346 5.39893 18.3346 10.0013ZM12.5013 7.5013C12.5013 8.88205 11.3821 10.0013 10.0013 10.0013C8.62055 10.0013 7.5013 8.88205 7.5013 7.5013C7.5013 6.12059 8.62055 5.0013 10.0013 5.0013C11.3821 5.0013 12.5013 6.12059 12.5013 7.5013ZM10.0013 17.0846C11.488 17.0846 12.8677 16.6266 14.0071 15.844C14.5103 15.4983 14.7253 14.8398 14.4328 14.304C13.8263 13.1932 12.5765 12.5013 10.0012 12.5013C7.42604 12.5013 6.17628 13.1931 5.56975 14.304C5.27718 14.8398 5.49222 15.4982 5.99544 15.8439C7.13479 16.6266 8.51455 17.0846 10.0013 17.0846Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'DirectorsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>